import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { HeaderBar } from 'op-components';
import { UX_FEATURE_OPTION_QUERY, GET_USER_PROFILE } from 'op-graphql/queries';
import ThemeShowcaseLayout from './ThemeShowcaseLayout';
import ColorShowcase from './ShowcasePages/Colors';
import TypographyShowcase from './ShowcasePages/TypographyShowcase';
import Chip from './ShowcasePages/Chip';
import ToggleButton from './ShowcasePages/ToggleButton';
import Tooltip from './ShowcasePages/Tooltip';
import TextEditorShowcase from './ShowcasePages/TextEditorShowcase';

const ThemeShowcase = () => {
  const { path } = useRouteMatch();

  // First check if user is authenticated
  const { data: userProfile, loading: userLoading } = useQuery(GET_USER_PROFILE, {
    errorPolicy: 'ignore',
    fetchPolicy: 'cache-first',
  });

  // Only check feature flag if user is authenticated
  const {
    data: featureOption,
    loading: featureLoading,
    error,
  } = useQuery(UX_FEATURE_OPTION_QUERY, {
    variables: { featureOptionName: 'ShowThemeShowcase' },
    errorPolicy: 'ignore',
    fetchPolicy: 'cache-first',
    skip: !userProfile?.user, // Skip the query if user is not authenticated
  });

  // Show loading spinner while checking authentication or feature flag
  if (userLoading || featureLoading) {
    return (
      <>
        <HeaderBar />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress />
        </Box>
      </>
    );
  }

  // If user is not authenticated or feature is not active, show access denied
  if (!userProfile?.user || error || !featureOption?.uxFeatureOption?.active) {
    return <></>;
  }

  return (
    <>
      <HeaderBar />
      <ThemeShowcaseLayout>
        <Switch>
          <Route exact path={path}>
            <Box sx={{ p: 3 }}>Select a section from the sidebar to view different aspects of the theme.</Box>
          </Route>
          <Route exact path={`${path}/colors`}>
            <ColorShowcase />
          </Route>
          <Route exact path={`${path}/typography`}>
            <TypographyShowcase />
          </Route>
          <Route exact path={`${path}/components/chip`}>
            <Chip />
          </Route>
          <Route exact path={`${path}/components/toggle-button`}>
            <ToggleButton />
          </Route>
          <Route exact path={`${path}/components/tooltip`}>
            <Tooltip />
          </Route>
          <Route exact path={`${path}/components/text-editor`}>
            <TextEditorShowcase />
          </Route>
        </Switch>
      </ThemeShowcaseLayout>
    </>
  );
};

export default ThemeShowcase;
